export enum CommunicationTypesEnum {
  events = 1,
  meetings = 2,
  warnings = 3,
  breakdowns = 4,
  chats = 10,
  lists = 99,
}
